<template>
  <FormGroup>
    <h5 class="name">รายการ</h5>
    <SelectOptionObject
      :value="scheduleItem.program"
      :options="programs"
      :label="'title'"
      :placeholder="'เลือกรายการ'"
      @onChanged="onSelectedProgram"
      @onSearch="loadPrograms" />
  </FormGroup>
</template>

<script>
import _ from 'lodash';
import { loadPrograms, loadProgramByKey } from '@/program/api';
import SelectOptionObject from '@/components/SelectOptionObject.vue';
import FormGroup from '@/components/FormGroup.vue';

export default {
  props: {
    scheduleItem: {
      type: Object,
      default: () => {},
    },
    updateScheduleItemStateError: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    FormGroup,
    SelectOptionObject,
  },
  data() {
    return {
      programs: [],
      episodes: [],
    };
  },
  created() {
    this.loadPrograms();
    this.loadProgramByKey(this.scheduleItem.programId);
  },
  methods: {
    async loadProgramByKey(programId) {
      if (programId) {
        const response = await loadProgramByKey(this.scheduleItem.programId);
        const program = _.cloneDeep(this.generateMockup(response.data));
        this.$emit('update:scheduleItem', {
          ...this.scheduleItem,
          program,
        });
      }
    },
    async loadPrograms(filter) {
      const response = await loadPrograms(filter);
      this.programs = response.data.data;
    },
    generateMockup(program) {
      const mockup = {
        features: {
          audioDesc: false,
          restrictedLicense: false,
          soundtrack: false,
          closedCaptions: false,
          signLanguage: false,
        },
        broadcastingChannels: {
          facebook: false,
          tv: false,
          twitter: false,
          web: false,
          youtube: false,
        },
      };
      return _.defaults(program, _.cloneDeep(mockup));
    },
    async onSelectedProgram(selectedOption) {
      if (selectedOption && selectedOption.id) {
        const response = await loadProgramByKey(selectedOption.id);
        const program = _.cloneDeep(this.generateMockup(response.data));
        this.$emit('update:scheduleItem', {
          ...this.scheduleItem,
          program,
          programId: program.id,
          episode: null,
          episodeId: null,
          tagline: program.tagline,
          taglineCustom: program.tagline,
          programTitle: program.title,
          coverImage: program.coverImage,
          coverImageCustom: program.coverImageCustom,
          broadcastingChannels: program.broadcastingChannels,
          features: program.features,
          contentCategory: program.contentCategory,
        });
      } else {
        this.$emit('update:scheduleItem', {
          ...this.scheduleItem,
          program: null,
          programId: null,
          episode: null,
          episodeId: null,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
</style>
